module.exports = __webpack_public_path__ + "img/substation-img_2.e2d698ea.png";